<template>
  <div >
    <Sheet
      :title="title"
      :visible="data"
      :width="700"
      padded
      @close="onClose"
    >
      <template v-slot:actions>
        <Button
          type="primary"
          v-if="!readonly"
          :disabled="!hasChanged"
          @click="commit"
        >{{updateButtonLabel}}</Button>
      </template>
      <component
        v-if="data"
        :is="propComponent"
        :doc="doc"
        :node="data"
        :readonly="readonly"
      />
      <!-- <br> -->
      <!-- propComponent: {{propComponent}}
      <pre>{{dataWithoutChildren}}</pre> -->
    </Sheet>
  </div>
</template>

<script>
import UI from 'fanplayr-ui'
import * as nodeComponents from './nodes'
import {getNodeComponent} from '../utils.ts'

export default {
  components: {
    ...nodeComponents
  },
  inject: ['$t'],
  props: {
    doc: {
      type: Object,
      required: true
    },
    node: {
      type: null
    },
    // 'create' or 'update'
    editMode: {
      type: String
    },
    readonly: {
      type: Boolean
    }
  },
  data() {
    return {
      data: null
    }
  },
  computed: {
    dataWithoutChildren() {
      return {
        ...this.data,
        children: undefined
      }
    },
    hasChanged() {
      if (this.editMode === 'create') {
        return true
      }
      return !UI.utils.isEqual(this.data, this.node)
    },
    updateButtonLabel() {
      if (this.editMode === 'create') {
        return this.$t('common.createAction')
      }
      return this.$t('common.updateAction')
    },
    propComponent() {
      return getNodeComponent(this.node.componentType, 'Properties')
    },
    title() {
      if (this.node) {
        const type = this.$t(`node.${this.node.componentType}.name`)
        return type
      }
      return null
    }
  },
  created() {
    this.$watch('node', function(node) {
      this.data = UI.utils.cloneDeep(node)
      window.currentNodeData = this.data
    }, {immediate: true})
  },
  methods: {
    commit() {
      this.$emit('commit', this.data)
    },
    async checkUnsaved() {
      if (this.hasChanged) {
        return this.$ui.confirm({
          title: this.$t('common.Discard changes'),
          content: this.$t('common.unsavedChangesMessage'),
          primaryActionLabel: this.$t('common.Discard changes'),
          primaryActionType: 'destructive',
          secondaryActionLabel: this.$t('common.Keep editing')
        })
      }
      return true
    },
    async onClose() {
      if (await this.checkUnsaved()) {
        this.$emit('close')
      }
    }
  }
}
</script>
